import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { apiCall } from "../calendar/calendarUtils";

const TIERS = [["free", "Kostenlos"], ["premium", "Premium"], ["premium_plus", "Premium Plus"]];
const STATUS = { active: "Aktiv", pending_parent: "Wartet auf Eltern", blocked: "Gesperrt" };

function Row({ m, token, onChanged }) {
  const update = async (body) => {
    try { await apiCall(token, `/training/admin/members/${m.member_id}`, { method: "PUT", body }); toast.success("Gespeichert"); onChanged(); } catch (e) { toast.error(e.message); }
  };
  return (
    <tr className="border-t border-white/5" data-testid={`member-row-${m.member_id}`}>
      <td className="py-3 pr-3"><p className="text-white">{m.first_name} {m.last_name}</p><p className="text-xs text-[#71717A]">{m.email}{m.is_minor && m.parent_email ? ` · Eltern: ${m.parent_email}` : ""}</p></td>
      <td className="py-3 pr-3 text-xs text-[#A1A1AA]">{m.birth_year} · {m.level}</td>
      <td className="py-3 pr-3"><span className={`text-xs ${m.status === "active" ? "text-green-400" : m.status === "pending_parent" ? "text-yellow-300" : "text-red-300"}`}>{STATUS[m.status] || m.status}</span></td>
      <td className="py-3 pr-3 text-xs text-[#A1A1AA]">{m.sessions}</td>
      <td className="py-3 pr-3">
        <select value={m.tier} onChange={(e) => update({ tier: e.target.value })} className="h-9 px-2 bg-[#0A0A0A] border border-white/15 text-white text-xs" data-testid={`member-tier-${m.member_id}`}>
          {TIERS.map(([id, l]) => <option key={id} value={id}>{l}</option>)}
        </select>
      </td>
      <td className="py-3">
        {m.status === "active" && <button onClick={() => update({ status: "blocked" })} className="text-xs text-red-300" data-testid={`member-block-${m.member_id}`}>Sperren</button>}
        {m.status === "blocked" && <button onClick={() => update({ status: "active" })} className="text-xs text-green-400" data-testid={`member-unblock-${m.member_id}`}>Entsperren</button>}
      </td>
    </tr>
  );
}

export function MembersPanel({ token }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const load = useCallback(() => apiCall(token, `/training/admin/members?q=${encodeURIComponent(q)}`).then((d) => setItems(d.items)).catch((e) => toast.error(e.message)), [token, q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  return (
    <div className="space-y-4" data-testid="training-members-panel">
      <div className="relative max-w-sm"><Search className="w-4 h-4 absolute left-3 top-3 text-[#71717A]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name oder E-Mail" className="w-full h-10 pl-9 bg-[#0A0A0A] border border-white/15 text-white text-sm" data-testid="members-search" /></div>
      <p className="text-xs text-[#71717A]">Tarif manuell setzen (z. B. für Tests oder Gutschriften). Automatische Freischaltung per Zahlung folgt in Phase 3.</p>
      <div className="overflow-x-auto"><table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wider text-[#71717A]"><th className="pb-2">Mitglied</th><th>Jahrgang · Niveau</th><th>Status</th><th>Einheiten</th><th>Tarif</th><th /></tr></thead>
        <tbody>{items.map((m) => <Row key={m.member_id} m={m} token={token} onChanged={load} />)}</tbody>
      </table></div>
      {!items.length && <p className="text-sm text-[#71717A]" data-testid="members-empty">Noch keine Mitglieder.</p>}
    </div>
  );
}
